<template>
  <div class="container" fluid>
    <b-modal
      scrollable
      id="createConfigs1Xml"
      @cancel="resetFields"
      @ok="createUrlSouce"
      size="xl"
      title="Configuraçao XML1"
    >
      <div class="isSimple" v-if="isSimple">
        <b-row>
          <b-col>
            <label>URLS</label>
          </b-col>
        </b-row>
        <b-row class="borderStyler">
          <b-col sm="11">
            <div v-for="item of clicked">
              <b-row class="my-1">
                <b-col sm="2">
                  <label>Url {{ item }}:</label>
                </b-col>
                <b-col sm="8">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the url"
                    v-model="urlArray[item - 1].url"
                  ></b-form-input>
                </b-col>
                <b-col sm="2" class="align-self-end">
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="removeUrlDiv(item - 1)"
                  >
                    <fa icon="minus" size="sm" />
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Priority:</label>
                </b-col>
                <b-col sm="8">
                  <b-form-select
                    :options="priorityOptions"
                    v-model="urlArray[item - 1].priority"
                  ></b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Novo url'"
              @click="addUrlDiv(clicked)"
              v-if="isSimple"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>TO EXTRACT</label>
          </b-col>
        </b-row>
        <b-row class="borderStyler"></b-row>
        <div v-for="item in addDivPartialUrl" :key="item">
          <b-row>
            <b-col>
              <label>Item {{ item }}</label>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="3">
              <b-col sm="12">
                <label>For:</label>
              </b-col>
            </b-col>
            <b-col sm="8">
              <b-form-checkbox-group
                :options="optionsForExtractUrl"
                value-field="item"
                text-field="name"
                v-model="selectedUrlForExtract[item - 1]"
              ></b-form-checkbox-group>
            </b-col>
            <b-col sm="1" class="align-self-end" v-if="item > 1">
              <b-button
                size="sm"
                variant="danger"
                v-b-popover.hover.right="'Eliminar Item'"
                @click="removeItemfromUrl(item - 1)"
              >
                <fa icon="minus" size="sm" />
              </b-button>
            </b-col>
          </b-row>
          <div v-if="addDivNotFullUrl[item - 1]">
            <b-row>
              <b-col sm="11">
                <div
                  v-for="idQuery of addDivToQuery[item - 1]"
                  class="queryBorder"
                  :key="idQuery"
                >
                  <b-row class="my-1">
                    <b-col sm="2">
                      <label>Query:</label>
                    </b-col>
                    <b-col sm="6">
                      <b-form-textarea
                        placeholder="Enter the query..."
                        rows="1"
                        id="text-area"
                        v-model="
                          toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                            .query
                        "
                      ></b-form-textarea>
                    </b-col>
                    <b-col sm="1" class="align-self-end" v-if="idQuery > 1">
                      <b-button
                        size="sm"
                        variant="danger"
                        @click="removeQueryOfUrl(item - 1, idQuery - 1)"
                      >
                        <fa icon="minus" size="sm" />
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="2">
                      <label>Parcial Url:</label>
                    </b-col>
                    <b-col sm="8">
                      <b-form-checkbox
                        v-model="isPartialQuery[item - 1][idQuery - 1]"
                        value="1"
                        unchecked-value="0"
                        @change="
                          toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                            .isPartial == false
                            ? (toReplaceOptions[item - 1].queryToReplace[
                                idQuery - 1
                              ].isPartial = true)
                            : (toReplaceOptions[item - 1].queryToReplace[
                                idQuery - 1
                              ].isPartial = false);
                          $forceUpdate();
                        "
                      ></b-form-checkbox>
                    </b-col>
                  </b-row>
                  <div
                    v-if="
                      toReplaceOptions[item - 1].queryToReplace[idQuery - 1]
                        .isPartial
                    "
                  >
                    <b-row class="my-1">
                      <b-col sm="2">
                        <label>To Replace:</label>
                      </b-col>
                      <b-col sm="6">
                        <b-form-input
                          size="sm"
                          placeholder="To replace in url query"
                          v-model="
                            toReplaceOptions[item - 1].queryToReplace[
                              idQuery - 1
                            ].toReplace
                          "
                        ></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="2">
                        <label>Prepare QS:</label>
                      </b-col>
                      <b-col sm="8">
                        <b-form-checkbox
                          v-model="
                            toReplaceOptions[item - 1].queryToReplace[
                              idQuery - 1
                            ].prepateQs
                          "
                          value="true"
                          unchecked-value="false"
                        ></b-form-checkbox>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
              <b-col sm="1; align-self-center">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  v-b-popover.hover.right="'Nova Query'"
                  @click="addQueryForUrl(addDivToQuery[item - 1], item)"
                  v-if="isSimple"
                >
                  <fa icon="plus" size="sm" />
                </b-button>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="2">
                <label>URL:</label>
              </b-col>
              <b-col sm="6">
                <b-form-input
                  size="sm"
                  placeholder="To replace in url query"
                  v-model="toReplaceOptions[item - 1].urlToReplace"
                ></b-form-input>
              </b-col>
            </b-row>
          </div>
        </div>
        <b-row style="margin-top: 5px" v-if="addDivNotFullUrl[0]">
          <b-col sm="11 text-right">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Novo item'"
              @click="addPartialUrlDiv(addDivPartialUrl)"
              v-if="isSimple"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <label>TO REMOVE</label>
          </b-col>
        </b-row>
        <b-row class="borderStyler"></b-row>
        <div v-for="item in addDivToRemove">
          <b-row>
            <b-col>
              <label>Item {{ item }}</label>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="3">
              <b-col sm="12">
                <label>For:</label>
              </b-col>
            </b-col>
            <b-col sm="8">
              <b-form-checkbox-group
                :options="optionsForRemoveUrl"
                value-field="item"
                text-field="name"
                v-model="selectedUrlForRemove[item - 1]"
              ></b-form-checkbox-group>
            </b-col>
            <b-col sm="1" class="align-self-end" v-if="item > 1">
              <b-button
                size="sm"
                variant="danger"
                v-b-popover.hover.right="'Eliminar Item'"
                @click="removeItemOfRemove(item - 1)"
              >
                <fa icon="minus" size="sm" />
              </b-button>
            </b-col>
          </b-row>
          <div v-if="addDivToRemoveQueries[item - 1]">
            <b-row>
              <b-col sm="11">
                <div
                  v-for="id of addDivToQueryOfRemove[item - 1]"
                  class="queryBorder"
                  :key="id"
                >
                  <b-row class="my-1">
                    <b-col sm="3">
                      <b-col sm="2">
                        <label>Query:</label>
                      </b-col>
                    </b-col>
                    <b-col sm="6">
                      <b-form-textarea
                        placeholder="Enter the query..."
                        rows="1"
                        id="text-area"
                        v-model="
                          toRemoveOptions[item - 1].queryToRemove[id - 1].query
                        "
                      ></b-form-textarea>
                    </b-col>
                    <b-col sm="1" class="align-self-end" v-if="id > 1">
                      <b-button
                        size="sm"
                        variant="danger"
                        @click="removeRemoveQueryUrl(item - 1, id - 1)"
                      >
                        <fa icon="minus" size="sm" />
                      </b-button>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="3">
                      <b-col sm="12">
                        <label>Parcial Url:</label>
                      </b-col>
                    </b-col>
                    <b-col sm="8">
                      <b-form-checkbox
                        v-model="isPartialQueryRemove[item - 1][id - 1]"
                        value="1"
                        unchecked-value="0"
                        @change="
                          toRemoveOptions[item - 1].queryToRemove[id - 1]
                            .isRemoved == false
                            ? (toRemoveOptions[item - 1].queryToRemove[
                                id - 1
                              ].isRemoved = true)
                            : (toRemoveOptions[item - 1].queryToRemove[
                                id - 1
                              ].isRemoved = false);
                          $forceUpdate();
                        "
                      ></b-form-checkbox>
                    </b-col>
                  </b-row>
                  <div
                    v-if="
                      toRemoveOptions[item - 1].queryToRemove[id - 1].isRemoved
                    "
                  >
                    <b-row>
                      <b-col sm="3">
                        <b-col sm="12">
                          <label>To Replace:</label>
                        </b-col>
                      </b-col>
                      <b-col sm="8">
                        <b-form-input
                          size="sm"
                          placeholder="To replace in url query"
                          v-model="
                            toRemoveOptions[item - 1].queryToRemove[id - 1]
                              .toReplace
                          "
                        ></b-form-input>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col sm="3">
                        <b-col sm="12">
                          <label>Prepare QS:</label>
                        </b-col>
                      </b-col>
                      <b-col sm="8">
                        <b-form-checkbox
                          v-model="
                            toRemoveOptions[item - 1].queryToRemove[id - 1]
                              .prepateQs
                          "
                          value="true"
                          unchecked-value="false"
                        ></b-form-checkbox>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
              <b-col sm="1; align-self-center">
                <b-button
                  variant="outline-primary"
                  size="sm"
                  v-b-popover.hover.right="'Nova Query'"
                  @click="
                    addQueryForRemove(addDivToQueryOfRemove[item - 1], item)
                  "
                  v-if="isSimple"
                >
                  <fa icon="plus" size="sm" />
                </b-button>
              </b-col>
            </b-row>
            <b-row class="my-1">
              <b-col sm="2">
                <b-col sm="12">
                  <label>URL:</label>
                </b-col>
              </b-col>
              <b-col sm="8">
                <b-form-input
                  size="sm"
                  placeholder="To replace in url query"
                  v-model="toRemoveOptions[item - 1].urlToRemove"
                ></b-form-input>
              </b-col>
            </b-row>
          </div>
        </div>
        <b-row style="margin-top: 5px" v-if="addDivToRemoveQueries[0]">
          <b-col sm="11 text-right">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Novo Item'"
              @click="
                addDivForItemToRemove(addDivToRemove);
                toRemoveAddQueries(addDivToRemove);
                $forceUpdate();
              "
              v-if="isSimple"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
      </div>
      <!--advanced Mode XML1-->
      <div class="isSimple" v-if="isSimple == false">
        <b-row class="my-1">
          <b-col>
            <b-form-textarea
              id="textarea-large"
              rows="12"
              size="sm"
              v-model="advancedXML"
            ></b-form-textarea>
          </b-col>
        </b-row>
      </div>
      <b-button
        variant="outline-primary"
        size="sm"
        v-if="isNotSearchEngine"
        @click="advancedMode(isSimple)"
        class="advance"
        >Advanced Mode</b-button
      >
    </b-modal>
    <!--News Configuration Modal-->
    <b-modal
      scrollable
      id="createXml2"
      @cancel="resetFields"
      @ok="createXml2"
      size="xl"
      title="Configuraçao XML2"
    >
      <div class="isSimple2" v-if="isSimple2">
        <b-row>
          <b-col style="text-align: center">
            <label>Title</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of addDivTitle">
              <b-row class="my-1">
                <b-col sm="2">
                  <label>XPATH:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the query"
                    v-model="titleArray[item - 1].query"
                    @change="$forceUpdate()"
                  ></b-form-input>
                </b-col>
                <b-col sm="1" class="align-self-end" v-if="item > 1">
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="removeTitleDiv(item - 1)"
                  >
                    <fa icon="minus" size="sm" />
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Confidence:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select
                    :options="priorityOptions"
                    v-model="titleArray[item - 1].confidenceLevel"
                  ></b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Nova Query'"
              @click="addTitleDiv(addDivTitle)"
              v-if="isSimple2"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: center">
            <label>Resume</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of addDivResume">
              <b-row class="my-1">
                <b-col sm="2">
                  <label>XPATH:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the query"
                    v-model="resumeArray[item - 1].query"
                    @change="$forceUpdate()"
                  ></b-form-input>
                </b-col>
                <b-col sm="1" class="align-self-end" v-if="item > 1">
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="removeResumeDiv(item - 1)"
                  >
                    <fa icon="minus" size="sm" />
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Confidence:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select
                    :options="priorityOptions"
                    v-model="resumeArray[item - 1].confidenceLevel"
                  ></b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Nova Query'"
              @click="addResumeDiv(addDivResume)"
              v-if="isSimple2"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: center">
            <label>Image</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of addDivImage">
              <b-row class="my-1">
                <b-col sm="2">
                  <label>XPATH:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the query"
                    v-model="imageArray[item - 1].query"
                    @change="$forceUpdate()"
                  ></b-form-input>
                </b-col>
                <b-col sm="1" class="align-self-end" v-if="item > 1">
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="removeImageDiv(item - 1)"
                  >
                    <fa icon="minus" size="sm" />
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Confidence:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select
                    :options="priorityOptions"
                    v-model="imageArray[item - 1].confidenceLevel"
                  ></b-form-select>
                </b-col>
              </b-row>
              <b-row v-if="item > 1">
                <b-col sm="2">
                  <label for="input-small">Partial Url:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-checkbox
                    v-model="imageArray[item - 1].isPartial"
                    value="1"
                    unchecked-value="0"
                    @change="
                      imageArray[item - 1].isPartial == '0'
                        ? (imageArray[item - 1].isPartial = '1')
                        : (imageArray[item - 1].isPartial = '0');
                      $forceUpdate();
                    "
                  ></b-form-checkbox>
                </b-col>
              </b-row>
              <b-row v-if="imageArray[item - 1].isPartial == '1'">
                <b-col sm="2">
                  <label for="input-small">To Replace:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    size="sm"
                    placeholder="To replace in url query"
                    v-model="imageArray[item - 1].toReplace"
                  ></b-form-input>
                </b-col>
              </b-row>
            </div>
            <b-row style="margin-bottom: 10px">
              <b-col sm="2">
                <label for="input-small">Url:</label>
              </b-col>
              <b-col sm="9">
                <b-form-input
                  size="sm"
                  placeholder="URL QUERY"
                  v-model="imageArrayUrl"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Nova Query'"
              @click="addImageDiv(addDivImage)"
              v-if="isSimple2"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: center">
            <label>Text</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of addDivText">
              <b-row class="my-1">
                <b-col sm="2">
                  <label>XPATH:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-input
                    size="sm"
                    placeholder="Enter the query"
                    v-model="textArray[item - 1].query"
                    @change="$forceUpdate()"
                  ></b-form-input>
                </b-col>
                <b-col sm="1" class="align-self-end" v-if="item > 1">
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="removeTextDiv(item - 1)"
                  >
                    <fa icon="minus" size="sm" />
                  </b-button>
                </b-col>
              </b-row>
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Confidence:</label>
                </b-col>
                <b-col sm="9">
                  <b-form-select
                    :options="confidenceOptions"
                    v-model="textArray[item - 1].confidenceLevel"
                  ></b-form-select>
                </b-col>
              </b-row>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Nova Query'"
              @click="addTextDiv(addDivText)"
              v-if="isSimple2"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col style="text-align: center">
            <label>Remove</label>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="11">
            <div v-for="item of addDivRemove">
              <b-row class="my-1">
                <b-col sm="2">
                  <label for="input-small">Reference :</label>
                </b-col>
                <b-col sm="8">
                  <b-form-select
                    :options="removeOptions"
                    v-model="removeArray[item - 1].reference"
                  ></b-form-select>
                </b-col>
                <b-col sm="1" class="align-self-end" v-if="item > 1">
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="removeRemoveDiv(item - 1)"
                  >
                    <fa icon="minus" size="sm" />
                  </b-button>
                </b-col>
              </b-row>
              <div v-for="idQuery of addQueryToRemove[item - 1]" :key="idQuery">
                <b-row class="my-1">
                  <b-col sm="2">
                    <label>XPATH:</label>
                  </b-col>
                  <b-col sm="9">
                    <b-form-input
                      size="sm"
                      placeholder="Enter the query"
                      v-model="removeArray[item - 1].queries[idQuery - 1].query"
                      @change="$forceUpdate()"
                    ></b-form-input>
                  </b-col>
                  <b-col sm="1" class="align-self-end" v-if="idQuery > 1">
                    <b-button
                      size="sm"
                      variant="danger"
                      @click="removeRemoveQueries(item - 1, idQuery - 1)"
                    >
                      <fa icon="minus" size="sm" />
                    </b-button>
                  </b-col>
                </b-row>
              </div>
              <b-col>
                <b-button
                  variant="outline-primary"
                  size="sm"
                  v-b-popover.hover.right="'Nova Query'"
                  @click="addRemoveDivQuery(addQueryToRemove[item - 1], item)"
                  v-if="isSimple2"
                >
                  <fa icon="plus" size="sm" />
                </b-button>
              </b-col>
            </div>
          </b-col>
          <b-col sm="1; align-self-center">
            <b-button
              variant="outline-primary"
              size="sm"
              v-b-popover.hover.right="'Novo Item'"
              @click="addRemoveDiv(addDivRemove)"
              v-if="isSimple2"
            >
              <fa icon="plus" size="sm" />
            </b-button>
          </b-col>
        </b-row>
      </div>
      <!--Advanced Mode XML2-->
      <div class="isSimple2" v-if="isSimple2 == false">
        <b-row class="my-1">
          <b-col>
            <b-form-textarea
              id="textarea-large"
              rows="12"
              size="sm"
              v-model="advancedXML2"
            ></b-form-textarea>
          </b-col>
        </b-row>
      </div>
      <b-button
        variant="outline-primary"
        size="sm"
        @click="advancedMode2(isSimple2)"
        class="advance2"
        >Advanced Mode</b-button
      >
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $ from "jquery";

export default {
  name: "CreateUrl",
  props: {
    isNotSearchEngine: Boolean,
    sourceObject: Object,
  },
  data() {
    return {
      clicked: 1,
      test: "",
      endpoint: "Sources",
      addDivTitle: 2,
      addDivToQuery: [1],
      addDivToQueryOfRemove: [1],
      addDivResume: 1,
      addDivImage: 1,
      addDivText: 1,
      addDivRemove: 1,
      addDivPartialUrl: 1,
      addDivToRemove: 1,
      addDivNotFullUrl: [false],
      addDivToRemoveQueries: [false],
      addTheDivForPartial: [],
      optionsForExtractUrl: [{ item: 0, name: "URL1" }],
      optionsForRemoveUrl: [{ item: 0, name: "URL1" }],
      selectedUrlForExtract: [[]],
      selectedUrlForRemove: [[]],
      addQueryToRemove: [1],
      isSimple: true,
      isPartialQuery: [[0]],
      isPartialQueryRemove: [[0]],
      isSimple2: true,
      disabled: true,
      document: $(document),
      advancedXML: "",
      advancedXML2: "",
      toReplaceOptions: [
        {
          toReplace: "",
          queryToReplace: [
            {
              query: "",
              toReplace: "",
              prepateQs: false,
              isPartial: false,
            },
          ],
          urlToReplace: "",
        },
      ],
      toRemoveOptions: [
        {
          queryToRemove: [
            {
              query: "",
              toReplace: "",
              prepateQs: false,
              isRemoved: false,
            },
          ],
          urlToRemove: "",
        },
      ],
      urlArray: [
        {
          url: "",
          priority: 0,
          checkedIsFullUrl: true,
          replace: "",
          query: "",
        },
      ],
      optionsFullUrl: [{ text: "URL1", value: 1 }],
      titleArray: [
        {
          query: "//meta[@property='og:title']/@content",
          confidenceLevel: 30,
        },
        {
          query: "//title",
          confidenceLevel: 20,
        },
      ],
      resumeArray: [
        {
          query: "//meta[@property='og:description']/@content",
          confidenceLevel: 30,
        },
      ],
      imageArray: [
        {
          query: "//meta[@property='og:image']/@content",
          isPartial: 0,
          topReplace: "",
          confidenceLevel: 30,
        },
      ],
      imageArrayUrl: "",
      textArray: [
        {
          query: "",
          confidenceLevel: 0,
        },
      ],
      removeArray: [
        {
          reference: 0,
          queries: [{ query: "" }],
        },
      ],
      SourceUrl: {
        c_u_Type: 1,
        c_u_Status: 0,
        c_u_Regularity: 0,
        c_u_ReferenceSource: "",
        c_u_Keywords: "",
        c_u_Parameters1: "",
        c_u_Parameters2: "",
      },
      priorityOptions: [
        { value: "0", text: "Please select a priority" },
        { value: "30", text: "High" },
        { value: "20", text: "Medium" },
        { value: "10", text: "Low" },
      ],
      statusOptions: [
        { value: "0", text: "Please select a status" },
        { value: "1", text: "Enabled" },
        { value: "2", text: "Disabled" },
      ],
      regularityOptions: [
        { value: "0", text: "Please select a regularity" },
        { value: "10", text: "10 Minutos" },
        { value: "20", text: "20 Minutos" },
        { value: "30", text: "30 Minutos" },
        { value: "40", text: "40 Minutos" },
        { value: "50", text: "50 Minutos" },
        { value: "60", text: "60 Minutos" },
      ],
      confidenceOptions: [
        { value: "0", text: "Please select a priority" },
        { value: "30", text: "High" },
        { value: "20", text: "Medium" },
        { value: "10", text: "Low" },
      ],
      removeOptions: [
        { value: "0", text: "Please select a Reference" },
        { value: "title", text: "Title" },
        { value: "resume", text: "Resume" },
        { value: "image", text: "Image" },
        { value: "text", text: "Text" },
      ],
    };
  },

  components: {},

  computed: {},

  watch: {
    isNotSearchEngine(newVal, oldVal) {
      if (newVal) {
        this.isSimple = true;
      } else {
        this.isSimple = false;
        this.advancedMode(false);
      }
      this.$forceUpdate();
    },
    selectedUrlForRemove(newVal, oldVal) {
      if (newVal[this.addDivToRemove - 1].length == 0) {
        this.addDivToRemoveQueries[this.addDivToRemove - 1] = false;
      }
      if (newVal[this.addDivToRemove - 1].length >= 1) {
        this.addDivToRemoveQueries[this.addDivToRemove - 1] = true;
      }
    },
    selectedUrlForExtract(newVal, oldVal) {
      if (newVal[this.addDivPartialUrl - 1].length == 0) {
        this.addDivNotFullUrl[this.addDivPartialUrl - 1] = false;
      }
      if (newVal[this.addDivPartialUrl - 1].length >= 1) {
        this.addDivNotFullUrl[this.addDivPartialUrl - 1] = true;
      }
    },
  },

  methods: {
    resetFields() {
      this.SourceUrl.c_u_ReferenceSource = "";
      this.SourceUrl.c_u_Status = 0;
      this.isPartialQuery = [[0]];
      this.isPartialQueryRemove = [[0]];
      this.SourceUrl.c_u_Regularity = 0;
      this.SourceUrl.c_u_Keywords = "";
      this.urlArray = [
        {
          url: "",
          priority: 0,
          checkedIsFullUrl: true,
        },
      ];
      this.toReplaceOptions = [
        {
          toReplace: "",
          queryToReplace: [
            {
              query: "",
              toReplace: "",
              prepateQs: false,
              isPartial: false,
            },
          ],
          urlToReplace: "",
        },
      ];
      this.toRemoveOptions = [
        {
          queryToRemove: [
            {
              query: "",
              toReplace: "",
              prepateQs: false,
              isRemoved: false,
            },
          ],
          urlToRemove: "",
        },
      ];
      this.addDivPartialUrl = 1;
      this.addDivToQuery = [1];
      this.addDivNotFullUrl = [];
      this.selectedUrlForExtract = [[]];
      this.selectedUrlForRemove = [[]];
      this.addDivRemove = 1;
      this.addDivToQueryOfRemove = [1];
      this.addDivToRemoveQueries = [false];
      this.addQueryToRemove = [1];
      this.addDivToRemove = 1;
      (this.addDivResume = 1),
        (this.addDivImage = 1),
        (this.addDivText = 1),
        (this.removeArray = [
          {
            reference: 0,
            queries: [{ query: "" }],
          },
        ]);
      (this.titleArray = [
        {
          query: "//meta[@property='og:title']/@content",
          confidenceLevel: 30,
        },
        {
          query: "//title",
          confidenceLevel: 20,
        },
      ]),
        (this.resumeArray = [
          {
            query: "//meta[@property='og:description']/@content",
            confidenceLevel: 30,
          },
        ]),
        (this.imageArray = [
          {
            query: "//meta[@property='og:image']/@content",
            isPartial: 0,
            topReplace: "",
            confidenceLevel: 30,
          },
        ]),
        (this.imageArrayUrl = ""),
        (this.textArray = [
          {
            query: "",
            confidenceLevel: 0,
          },
        ]);
      this.clicked = 1;
      this.isSimple = true;
    },
    semicolonKey: function (event) {
      if (event.key != undefined) {
        if (event.keyCode == 32) {
          this.SourceUrl.c_u_Keywords = `${this.SourceUrl.c_u_Keywords.replace(
            /\s/g,
            ""
          )};`;
        }
      }
    },
    createXml2(evt) {
      const xml = require("xml");
      // structur of the xml for the parameters2
      if (this.isSimple2) {
        let xml2 = [
          {
            Configuration: [
              { _attr: { For: "News" } },
              { URLs: "" },
              {
                ToExtract: [
                  {
                    Item: [
                      { _attr: { ForURLsID: "", Reference: "title" } },
                      { Queries: [] },
                      { URL: [] },
                    ],
                  },
                  {
                    Item: [
                      { _attr: { ForURLsID: "", Reference: "resume" } },
                      { Queries: [] },
                      { URL: [] },
                    ],
                  },
                  {
                    Item: [
                      { _attr: { ForURLsID: "", Reference: "image" } },
                      { Queries: [] },
                      { URL: "" },
                    ],
                  },
                  {
                    Item: [
                      { _attr: { ForURLsID: "", Reference: "text" } },
                      { Queries: [] },
                      { URL: [] },
                    ],
                  },
                ],
              },
              { ToRemove: [] },
            ],
          },
        ];

        //for loop to create the queries of title in the xml
        for (var index = 0; index < this.titleArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[0].Item[1].Queries.push({
            Query: [
              {
                _attr: {
                  Id: index + 1,
                  ConfidenceLevel: this.titleArray[index].confidenceLevel,
                  IsURL: "false",
                  IsFullURL: "false",
                  ToReplace: "",
                  PrepareTextForQS: "false",
                },
              },
              this.titleArray[index].query,
            ],
          });
        }

        //for loop to create the queries of resume in the xml
        for (var index = 0; index < this.resumeArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[1].Item[1].Queries.push({
            Query: [
              {
                _attr: {
                  Id: index + 1,
                  ConfidenceLevel: this.resumeArray[index].confidenceLevel,
                  IsURL: "false",
                  IsFullURL: "false",
                  ToReplace: "",
                  PrepareTextForQS: "false",
                },
              },
              this.resumeArray[index].query,
            ],
          });
        }

        //for loop to create the queries of image in the xml
        for (var index = 0; index < this.imageArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[2].Item[1].Queries.push({
            Query: [
              {
                _attr: {
                  Id: index + 1,
                  ConfidenceLevel: this.imageArray[index].confidenceLevel,
                  IsURL: "true",
                  IsFullURL:
                    this.imageArray[index].isPartial == "1" ? "false" : "true",
                  ToReplace:
                    this.imageArray[index].isPartial == "1"
                      ? this.imageArray[index].toReplace
                      : "",
                  PrepareTextForQS: "false",
                },
              },
              this.imageArray[index].query,
            ],
          });
          if (this.imageArray[index].isPartial == "1") {
            xml2[0].Configuration[2].ToExtract[2].Item[2].URL = this.imageArrayUrl;
          }
        }

        //for loop to create the queries of text in the xml
        for (var index = 0; index < this.textArray.length; index++) {
          xml2[0].Configuration[2].ToExtract[3].Item[1].Queries.push({
            Query: [
              {
                _attr: {
                  Id: index + 1,
                  ConfidenceLevel: this.textArray[index].confidenceLevel,
                  IsURL: "false",
                  IsFullURL: "false",
                  ToReplace: "",
                  PrepareTextForQS: "false",
                },
              },
              this.textArray[index].query,
            ],
          });
        }
        // for loop to create the queries of remove in the xml
        for (var index = 0; index < this.removeArray.length; index++) {
          xml2[0].Configuration[3].ToRemove.push({
            Item: [
              {
                _attr: {
                  ForURLsId: "",
                  Reference: this.removeArray[index].reference,
                },
              },
              {
                Queries: [],
              },
            ],
          });
          for (let i = 0; i < this.removeArray[index].queries.length; i++) {
            xml2[0].Configuration[3].ToRemove[index].Item[1].Queries.push({
              Query: [
                {
                  _attr: {
                    Id: i + 1,
                    ConfidenceLevel: 0,
                    IsURL: "false",
                    IsFullURL: "false",
                    ToReplace: "",
                    PrepareTextForQS: "false",
                  },
                },
                this.removeArray[index].queries[i].query,
              ],
            });
          }
        }
        this.SourceUrl.c_u_Parameters2 = xml(xml2, {
          declaration: { version: "1.0", encoding: "UTF-8" },
        });
      } else {
        this.SourceUrl.c_u_Parameters2 = this.advancedXML2;
      }

      this.$emit(
        "ok",
        this.SourceUrl.c_u_Parameters1,
        this.SourceUrl.c_u_Parameters2
      );
    },
    async createUrlSouce(evt) {
      if (this.isSimple) {
        // create the xml for the source
        const xml = require("xml");
        let indexUrls = [];
        let queryIndex = 1;
        //structure for the parameters1 xml
        let xml1 = [
          {
            Configuration: [
              { _attr: { For: "List" } },
              { URLs: [] },
              { ToExtract: [] },
              { ToRemove: [] },
            ],
          },
        ];

        // for loop to create the url queries in the xml
        for (var index = 0; index < this.urlArray.length; index++) {
          xml1[0].Configuration[1].URLs.push({
            URL: [
              {
                _attr: {
                  Id: index + 1,
                  Priority: this.urlArray[index].priority,
                },
              },
              this.urlArray[index].url,
            ],
          });
          if (this.urlArray[index].checkedIsFullUrl == true) {
            indexUrls.push(index + 1);
          }
        }

        let arrayForToReplace = [];
        let stringOfUrl = "";
        let numbers = [];
        for (
          var index = 0;
          index < this.selectedUrlForExtract.length;
          index++
        ) {
          for (let i = 0; i < this.selectedUrlForExtract[index].length; i++) {
            numbers.push(this.selectedUrlForExtract[index][i] + 1);
          }
          this.selectedUrlForExtract[index].sort();
          stringOfUrl = numbers.join(",");
          //Create the final array for the to replace
          arrayForToReplace.push({
            stringForUrlsId: stringOfUrl,
            url: this.toReplaceOptions[index].urlToReplace,
            query: this.toReplaceOptions[index].queryToReplace,
          });
        }

        for (var index = 0; index < arrayForToReplace.length; index++) {
          xml1[0].Configuration[2].ToExtract.push({
            Item: [
              {
                _attr: { ForURLsId: arrayForToReplace[index].stringForUrlsId },
              },
              {
                Queries: [],
              },
              {
                URL: arrayForToReplace[index].url,
              },
            ],
          });
          for (let u = 0; u < arrayForToReplace[index].query.length; u++) {
            xml1[0].Configuration[2].ToExtract[index].Item[1].Queries.push({
              Query: [
                {
                  _attr: {
                    Id: u + 1,
                    ConfidenceLevel: "0",
                    IsURL: "true",
                    IsFullURL:
                      arrayForToReplace[index].query[u].isPartial == true
                        ? "false"
                        : "true",
                    ToReplace:
                      arrayForToReplace[index].query[u].toReplace != ""
                        ? arrayForToReplace[index].query[u].toReplace.includes(
                            "#"
                          ) == true
                          ? arrayForToReplace[index].query[u].toReplace
                          : "#" +
                            arrayForToReplace[index].query[u].toReplace +
                            "#"
                        : "",
                    PrepareTextForQS:
                      arrayForToReplace[index].query[u].prepateQs,
                  },
                },
                this.sourceObject.c_u_Type != 2
                  ? arrayForToReplace[index].query[u].query.includes("/a") ==
                    true
                    ? arrayForToReplace[index].query[u].query.includes(
                        "/@href"
                      ) == true
                      ? arrayForToReplace[index].query[u].query
                      : arrayForToReplace[index].query[u].query + "/@href"
                    : arrayForToReplace[index].query[u].query
                  : arrayForToReplace[index].query[u].query,
              ],
            });
          }
          let arrayToRemoveItems = [];
          let stringOfUrls = "";
          let numbers = [];
          // to create the toRemove Items with queries
          for (
            var index = 0;
            index < this.selectedUrlForRemove.length;
            index++
          ) {
            if (this.selectedUrlForRemove[index].length >= 1) {
              for (
                let i = 0;
                i < this.selectedUrlForRemove[index].length;
                i++
              ) {
                numbers.push(this.selectedUrlForRemove[index][i] + 1);
              }
              this.selectedUrlForRemove[index].sort();
              stringOfUrls = numbers.join(",");
              arrayToRemoveItems.push({
                stringForUrlsId: stringOfUrls,
                url: this.toRemoveOptions[index].urlToRemove,
                query: this.toRemoveOptions[index].queryToRemove,
              });
            }
          }

          if (arrayToRemoveItems != []) {
            for (var index = 0; index < arrayToRemoveItems.length; index++) {
              xml1[0].Configuration[3].ToRemove.push({
                Item: [
                  {
                    _attr: {
                      ForURLsId: arrayToRemoveItems[index].stringForUrlsId,
                    },
                  },
                  {
                    Queries: [],
                  },
                  {
                    URL: arrayToRemoveItems[index].url,
                  },
                ],
              });

              for (let u = 0; u < arrayToRemoveItems[index].query.length; u++) {
                xml1[0].Configuration[3].ToRemove[index].Item[1].Queries.push({
                  Query: [
                    {
                      _attr: {
                        Id: u + 1,
                        ConfidenceLevel: "0",
                        IsURL: "true",
                        IsFullURL:
                          arrayToRemoveItems[index].query[u].isRemoved == true
                            ? "false"
                            : "true",
                        ToReplace:
                          arrayToRemoveItems[index].query[u].toReplace != ""
                            ? arrayToRemoveItems[index].query[
                                u
                              ].toReplace.includes("#") == true
                              ? arrayToRemoveItems[index].query[u].toReplace
                              : "#" +
                                arrayToRemoveItems[index].query[u].toReplace +
                                "#"
                            : "",
                        PrepareTextForQS:
                          arrayToRemoveItems[index].query[u].prepateQs,
                      },
                    },
                    this.sourceObject.c_u_Type != 2
                      ? arrayForToReplace[index].query[u].query.includes(
                          "/a"
                        ) == true
                        ? arrayForToReplace[index].query[u].query.includes(
                            "/@href"
                          ) == true
                          ? arrayForToReplace[index].query[u].query
                          : arrayForToReplace[index].query[u].query + "/href"
                        : arrayForToReplace[index].query[u].query
                      : arrayForToReplace[index].query[u].query,
                  ],
                });
              }
            }
          }
        }

        this.SourceUrl.c_u_Parameters1 = xml(xml1, {
          declaration: { version: "1.0", encoding: "UTF-8" },
        });
      } else {
        this.SourceUrl.c_u_Parameters1 = this.advancedXML;
      }
      //api post to create the source
      // this.$api.data.endpoint = this.endpoint;
      // await this.$api.data.create(this.SourceUrl);
      this.$emit(
        "ok",
        this.SourceUrl.c_u_Parameters1,
        this.SourceUrl.c_u_Parameters2
      );
      this.$forceUpdate();

      //remove the values from the modal
      //this.resetFields();
    },

    addQueryForUrl(evt, item) {
      this.addDivToQuery[item - 1]++;
      this.toReplaceOptions[item - 1].queryToReplace[
        this.addDivToQuery[item - 1] - 1
      ] = { query: "", toReplace: "", prepateQs: false, isPartial: false };
      this.$forceUpdate();
    },
    addQueryForRemove(evt, item) {
      this.addDivToQueryOfRemove[item - 1]++;
      this.toRemoveOptions[item - 1].queryToRemove[
        this.addDivToQueryOfRemove[item - 1] - 1
      ] = { query: "", toReplace: "", prepateQs: false, isRemoved: false };
      this.$forceUpdate();
    },
    toRemoveAddQueries(item) {
      if (this.addDivToRemoveQueries[item - 1] == undefined) {
        this.addDivToRemoveQueries[item - 1] = false;
        this.addDivToQueryOfRemove[item - 1] = 1;
      }
      this.$forceUpdate();
    },
    addDivForItemToRemove() {
      this.addDivToRemove++;
      if (this.toRemoveOptions[this.addDivToRemove - 1] == undefined) {
        this.toRemoveOptions[this.addDivToRemove - 1] = {
          toReplace: "",
          queryToRemove: [],
          urlToReplace: "",
        };
        this.toRemoveOptions[this.addDivToRemove - 1].queryToRemove[0] = {
          query: "",
          toReplace: "",
          prepateQs: false,
          isRemoved: false,
        };
        this.isPartialQueryRemove[this.addDivToRemove - 1] = [0];
        this.$forceUpdate();
      }
    },
    addPartialUrlDiv(evt) {
      this.addDivPartialUrl++;
      if (this.toReplaceOptions[this.addDivPartialUrl - 1] == undefined) {
        this.toReplaceOptions[this.addDivPartialUrl - 1] = {
          toReplace: "",
          queryToReplace: [],
          urlToReplace: "",
        };
        this.toReplaceOptions[this.addDivPartialUrl - 1].queryToReplace[0] = {
          query: "",
          toReplace: "",
          prepateQs: false,
          isPartial: false,
        };
        this.addDivToQuery[this.addDivPartialUrl - 1] = 1;
      }
      this.isPartialQuery[this.addDivPartialUrl - 1] = [0];
      this.$forceUpdate();
    },
    addTitleDiv(evt) {
      this.addDivTitle++;
      this.titleArray[this.addDivTitle - 1] = { query: "", confidenceLevel: 0 };
    },

    addResumeDiv(evt) {
      this.addDivResume++;
      this.resumeArray[this.addDivResume - 1] = {
        query: "",
        confidenceLevel: 0,
      };
    },

    addImageDiv(evt) {
      this.addDivImage++;
      this.imageArray[this.addDivImage - 1] = {
        query: "",
        isPartial: 0,
        topReplace: "",
        confidenceLevel: 0,
      };
    },

    addTextDiv(evt) {
      this.addDivText++;
      this.textArray[this.addDivText - 1] = { query: "", confidenceLevel: 0 };
    },
    addUrlDiv(evt) {
      this.clicked++;
      this.optionsForRemoveUrl.push({
        item: this.clicked - 1,
        name: `URL${this.clicked}`,
      });
      this.optionsForExtractUrl.push({
        item: this.clicked - 1,
        name: `URL${this.clicked}`,
      });
      this.urlArray.push({
        url: "",
        priority: 0,
        checkedIsFullUrl: true,
        replace: "",
        query: "",
      });
    },
    addRemoveDiv(evt) {
      this.addDivRemove++;
      this.removeArray[this.addDivRemove - 1] = {
        reference: 0,
        queries: [{ query: "" }],
      };
      this.addQueryToRemove[this.addDivRemove - 1] = 1;
    },
    addRemoveDivQuery(evt, item) {
      this.addQueryToRemove[item - 1]++;
      this.removeArray[item - 1].queries[
        this.addQueryToRemove[item - 1] - 1
      ] = { query: "" };
      this.$forceUpdate();
    },

    advancedMode(evt) {
      if (this.isSimple == true) {
        this.advancedXML = `<?xml version="1.0" encoding="utf-8"?>
<Configuration For="list">
    <URLs>
    </URLs>
    <ToExtract>
        <Item ForURLsId="" Reference="">
            <Queries>
                <Query Id="1" ConfidenceLevel="0" IsURL="true" IsFullURL="true" ToReplace="" PrepareTextForQS="false">
                </Query>
            </Queries>
            <URL></URL>
        </Item>
    </ToExtract>
    <ToRemove></ToRemove>
</Configuration>`;

        document.getElementsByClassName("advance")[0].innerText = "Simple Mode";
        this.isSimple = false;
      } else {
        this.advancedXML = `<?xml version="1.0" encoding="utf-8"?>
<Configuration For="list">
    <URLs>
    </URLs>
    <ToExtract>
        <Item ForURLsId="" Reference="">
            <Queries>
                <Query Id="1" ConfidenceLevel="0" IsURL="true" IsFullURL="true" ToReplace="" PrepareTextForQS="false">
                </Query>
            </Queries>
            <URL></URL>
        </Item>
    </ToExtract>
    <ToRemove></ToRemove>
</Configuration>`;
        document.getElementsByClassName("advance")[0].innerText =
          "Advanced Mode";
        this.isSimple = true;
      }
    },
    advancedMode2(evt) {
      if (this.isSimple2 == true) {
        this.advancedXML2 = `<?xml version="1.0" encoding="utf-8"?>
<Configuration For="news">
    <URLs></URLs>
    <ToExtract>
        <Item ForURLsId="" Reference="title">
            <Queries>
                <Query Id="1" ConfidenceLevel="30" IsURL="false" IsFullURL="false" ToReplace="" PrepareTextForQS="false">
                    //meta[@property='og:title']/@content
                </Query>
                <Query Id="2" ConfidenceLevel="20" IsURL="false" IsFullURL="false" ToReplace="" PrepareTextForQS="false">
                    //title
                </Query>
            </Queries>
            <URL></URL>
        </Item>
        <Item ForURLsId="" Reference="resume">
            <Queries>
                <Query Id="1" ConfidenceLevel="30" IsURL="false" IsFullURL="false" ToReplace="" PrepareTextForQS="false">
                    //meta[@property='og:description']/@content
                </Query>
            </Queries>
            <URL></URL>
        </Item>
        <Item ForURLsId="" Reference="image">
            <Queries>
                <Query Id="1" ConfidenceLevel="30" IsURL="true" IsFullURL="true" ToReplace="" PrepareTextForQS="false">
                    //meta[@property='og:image']/@content
                </Query>
            </Queries>
            <URL></URL>
        </Item>
        <Item ForURLsId="" Reference="text">
            <Queries>
            </Queries>
            <URL></URL>
        </Item>
    </ToExtract>
    <ToRemove></ToRemove>
</Configuration>`;

        document.getElementsByClassName("advance2")[0].innerText =
          "Simple Mode";
        this.isSimple2 = false;
      } else {
        document.getElementsByClassName("advance2")[0].innerText =
          "Advanced Mode";
        this.isSimple2 = true;
      }
    },
    removeUrlDiv(evt) {
      this.urlArray.splice(evt, 1);
      this.optionsForExtractUrl.splice(evt, 1);
      // for to remove the url if its already selected
      for (var index = 0; index < this.selectedUrlForExtract.length; index++) {
        _.remove(this.selectedUrlForExtract[index], function (id) {
          return id == evt;
        });
      }
      this.optionsForRemoveUrl.splice(evt, 1);
      // for to remove the url if its already selected
      for (var index = 0; index < this.selectedUrlForRemove.length; index++) {
        _.remove(this.selectedUrlForRemove[index], function (id) {
          return id == evt;
        });
      }
      this.clicked--;
    },
    removeTitleDiv(evt) {
      this.titleArray.splice(evt, 1);
      this.addDivTitle--;
    },
    removeResumeDiv(evt) {
      this.resumeArray.splice(evt, 1);
      this.addDivResume--;
    },
    removeImageDiv(evt) {
      this.imageArray.splice(evt, 1);
      this.addDivImage--;
    },

    removeTextDiv(evt) {
      this.textArray.splice(evt, 1);
      this.addDivText--;
    },
    removeRemoveQueries(item, query) {
      this.removeArray[item].queries.splice(query, 1);
      this.addQueryToRemove[item]--;
      this.$forceUpdate();
    },
    removeQueryOfUrl(item, query) {
      this.toReplaceOptions[item].queryToReplace.splice(query, 1);
      this.addDivToQuery[item]--;
      this.$forceUpdate();
    },
    removeRemoveQueryUrl(item, query) {
      this.toRemoveOptions[item].queryToRemove.splice(query, 1);
      this.addDivToQueryOfRemove[item]--;
      this.$forceUpdate();
    },
    removeItemOfRemove(item) {
      this.addDivToRemove--;
      this.addDivToRemoveQueries.splice(item, 1);
      this.selectedUrlForRemove.splice(item, 1);
      this.toRemoveOptions.splice(item, 1);
      this.$forceUpdate();
    },
    removeItemfromUrl(item) {
      this.addDivPartialUrl--;
      this.selectedUrlForExtract.splice(item, 1);
      this.toReplaceOptions.splice(item, 1);
      this.addDivToQuery.splice(item, 1);
      this.addDivNotFullUrl.splice(item, 1);
      this.$forceUpdate();
    },
    removeRemoveDiv(evt) {
      this.removeArray.splice(evt, 1);
      this.addDivRemove--;
    },
  },
  mounted() {},
};
</script>
<style scoped>
.borderStyler {
  border-top: 2px dashed #ecebea;
}
.queryBorder:nth-of-type(n + 2) {
  border-top: 2px dashed #ecebea;
}
</style>



// WEBPACK FOOTER //
// src/components/Sources/CreateUrl.vue